/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_External_Bookings_Trial_Activity_CtaInputs */

const en_admin_dashboard_external_bookings_trial_activity_cta = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try External Bookings Now`)
};

const de_admin_dashboard_external_bookings_trial_activity_cta = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externe Buchungen testen`)
};

const es_admin_dashboard_external_bookings_trial_activity_cta = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba las Reservas Externas ahora`)
};

const fr_admin_dashboard_external_bookings_trial_activity_cta = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essayez les Réservations Externes`)
};

const it_admin_dashboard_external_bookings_trial_activity_cta = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prova le Prenotazioni Esterne ora`)
};

const pt_br2_admin_dashboard_external_bookings_trial_activity_cta = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimente Reservas Externas agora`)
};

const pl_admin_dashboard_external_bookings_trial_activity_cta = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wypróbuj Rezerwacje Zewnętrzne teraz`)
};

const hu_admin_dashboard_external_bookings_trial_activity_cta = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próbálja ki a Külső foglalásokat`)
};

const ro_admin_dashboard_external_bookings_trial_activity_cta = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incercati Rezervarile Externe Acum`)
};

/**
* | output |
* | --- |
* | "Try External Bookings Now" |
*
* @param {Admin_Dashboard_External_Bookings_Trial_Activity_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_external_bookings_trial_activity_cta = /** @type {((inputs?: Admin_Dashboard_External_Bookings_Trial_Activity_CtaInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_External_Bookings_Trial_Activity_CtaInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_external_bookings_trial_activity_cta(inputs)
	if (locale === "de") return de_admin_dashboard_external_bookings_trial_activity_cta(inputs)
	if (locale === "es") return es_admin_dashboard_external_bookings_trial_activity_cta(inputs)
	if (locale === "fr") return fr_admin_dashboard_external_bookings_trial_activity_cta(inputs)
	if (locale === "it") return it_admin_dashboard_external_bookings_trial_activity_cta(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_external_bookings_trial_activity_cta(inputs)
	if (locale === "pl") return pl_admin_dashboard_external_bookings_trial_activity_cta(inputs)
	if (locale === "hu") return hu_admin_dashboard_external_bookings_trial_activity_cta(inputs)
	return ro_admin_dashboard_external_bookings_trial_activity_cta(inputs)
});
export { admin_dashboard_external_bookings_trial_activity_cta as "admin.dashboard.external_bookings_trial_activity_cta" }